'use strict';
import MemberPopup from './member-popup';
const $ = jQuery.noConflict();

const Popups = {

	$domUrl: $('body').data('url'),

	init: function() {
		$(window).on('load', ()=>{
			const param = MemberPopup.getUrlParameter('brand');
			if (!param) return;
			showPopup(param);
		});
		function showPopup(whichpopup){
			if ($(`[data-brand-id='${whichpopup}']`).length < 1) return;

			$('.js-overlay-bg').addClass('active');
			$('.popup-' + whichpopup).addClass('active');
			$('body').addClass('prevent-scroll');

			// push url address
			const url = MemberPopup.$domUrl + '?brand=' + whichpopup;
			window.history.pushState('', '', url);
		}
		function closePopup(){
			$('.js-overlay-bg').removeClass('active');
			$('.js-popups-content').removeClass('active');
			$('body').removeClass('prevent-scroll');

			// push url address
			window.history.pushState('', '', MemberPopup.$domUrl);
		}
		$('.show-popup').on('click', function(event){
			event.preventDefault();
			const selectedPopup = $(this).data('showpopup');
			showPopup(selectedPopup);
		});
		$('.js-close-popup, .js-overlay-bg').on('click', function() {
			closePopup();
		});
		$(document).on('keyup', function(e) {
			if (e.keyCode === 27) {
				closePopup();
			}
		});
	}
};

export default Popups;
